<mat-dialog-content class="dialog-container">
  <div class="dialog-title">
    {{ 'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.TITLE' | translate }}
  </div>

  <div class="dialog-container__card-divider"></div>
  <div fusePerfectScrollbar class="dialog-content">
    <ng-container *ngIf="maintenances && maintenances.length > 0">
      <span class="description">
        {{ 'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.DESCRIPTION' | translate }}
      </span>
      <mat-radio-group [(ngModel)]="selectedMaintenance">
        <mat-radio-button class="first-radio-group" [value]="null">
          <div>
            <span>
              {{
                'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.NO_PREVIOUS_MAINTENANCE' | translate
              }}
            </span>
          </div>
        </mat-radio-button>
        <div *ngFor="let maintenance of maintenances" class="list-item">
          <mat-radio-button [value]="maintenance" class="list-item__radio">
            <div class="list-item__header">
              <span>
                <strong>{{ maintenance.number }}</strong>
                -
                {{ maintenance.maintenanceType.name }}
              </span>
              <button mat-icon-button (click)="openPreviousMaintenance(maintenance)">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>

            <div class="list-item__address" title="{{ maintenance.location.address.formattedAddress }}">
              {{ maintenance.location.address.formattedAddress }}
            </div>

            <div class="list-item__footer">
              <span class="open-date"> Data de Abertura: {{ maintenance.openedAt | date: 'dd/MM/yyyy' }} </span>
              <span class="company-name" title="{{ maintenance.company.name }}">
                {{ maintenance.company.name }}
              </span>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </ng-container>
    <ng-container *ngIf="!maintenances || maintenances.length === 0">
      <span class="description">
        {{ 'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.EQUIPMENT_DESCRIPTION' | translate }}
      </span>
    </ng-container>
  </div>

  <div class="dialog-footer">
    <button mat-button mat-dialog-close class="footer-buttons__cancel">
      {{ 'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.ACTIONS.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="selectedMaintenance === undefined && maintenances && maintenances.length"
      class="footer-buttons__continue"
      (click)="continue()"
    >
      {{
        (maintenances && maintenances.length
          ? 'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.ACTIONS.CONTINUE_AND_CREATE'
          : 'MAINTENANCES.CREATE_DIALOG.PREVIOUS_MAINTENANCE_WARRANTY_DIALOG.ACTIONS.CONTINUE'
        ) | translate
      }}
    </button>
  </div>
</mat-dialog-content>
